import { TwoFactorError, TwoFactorMethod } from "@/api/twoFactor";

/**
 * Maps the backend's stable `code` to copy a user can act on. `INVALID_CODE` and `INVALID_PASSWORD`
 * must stay distinct - telling someone their code is wrong when they mistyped their password sends
 * them to check the wrong app. The method points a rejected code at the place it comes from.
 * Why a code is refused (a backup code, one used a moment ago) is taught beside the field, not in
 * the error.
 */
export const describeError = (e: unknown, method?: TwoFactorMethod): string => {
  if (!(e instanceof TwoFactorError)) {
    return "Something went wrong. Please try again.";
  }
  switch (e.code) {
    case "INVALID_CODE":
      if (method === "TOTP") {
        return "That code didn't work. Check your authenticator app and try again.";
      }
      if (method === "EMAIL") {
        return "That code didn't work. Check your email for the code and try again.";
      }
      return "That code didn't work. Check it and try again.";
    case "INVALID_PASSWORD":
      return "That password didn't match.";
    case "ALREADY_ACTIVE":
      return "Two-step verification is already on.";
    case "NOT_ENROLLED":
      return "Two-step verification is not on.";
    case "TOO_MANY_ATTEMPTS":
      return e.retryAfterSeconds
        ? `Too many attempts. Please wait ${e.retryAfterSeconds} seconds and try again.`
        : "Too many attempts. Please wait a moment and try again.";
    default:
      return "Something went wrong. Please try again.";
  }
};
